<template>
	<div id="classDetail">
		<v-header :selectedItemVal="3" ref="header"></v-header>

		<div class="main">
			<div class="classDetail">
				<div class="page_tag">
					<h2>
						首页 &nbsp;> &nbsp; 牛人课 &nbsp;> &nbsp; 课程介绍
					</h2>
				</div>
				<div class="page_content">
					<div class="video_content">
						<div class="video_kanban">
							<div class="prism-player" id="bullClassPlayer"></div>
						</div>
					</div>
					<div class="class_content">
						<div class="class_content_left">
							<el-tabs v-model="activeName" @tab-click="handleClick">
								<el-tab-pane label="课程介绍" name="first">
									<div class="class_desc" v-if="activeClassData">
										<div class="class-name">
											{{ activeClassData.ncName }}
										</div>
										<div class="class-data">
											<div>
												讲师:{{ shouxiData.auName }}
											</div>
											<div>
												{{ shouxiData.dfDycount }}
											</div>
										</div>
										<div class="class-desc" v-html="activeClassData.ncDescribeFwb"></div>
									</div>
								</el-tab-pane>
								<el-tab-pane label="内容列表" name="second">
									<div class="class-list">
										<div class="class-item" v-for="(item,index) in classData"
											@click="changeClassPlay(item)">
											<div class="item-img">
												<img :src="item.ncdBigImg" alt="">
											</div>
											<div class="item-content">
												<p>{{ item.ncdName }}</p>
												<p>{{ item.createTime }}</p>
											</div>
										</div>
									</div>
								</el-tab-pane>
							</el-tabs>
						</div>
						<div class="class_content_right">
							<div class="c_content_r_top">
								<div class="classUserInfo">
									<div class="logo">
										<img :src="shouxiData.auPhoto" alt="" v-if="shouxiData.auPhoto">
										<img src="../../assets/img/logo.png" alt="" v-else>
									</div>
									<div class="name">
										<span style="font-size: 24px;color: #222222;">{{ shouxiData.auName }}</span>
										<span
											style="background: #C60B09;width: 32px;font-size:12px;border-radius: 0px 4px 0px 4px;height: 20px;">{{ shouxiData.sxType }}</span>
									</div>
									<div class="role">
										<div class="Tech" v-for="(item,index) in (shouxiData.usLabel || '').split(',')">
											{{ item}}</div>
									</div>
									<div class="sac_number">
										SAC资格证号：
										<span v-if="shouxiData.usAdvisorCode">
											{{ shouxiData.usAdvisorCode }}
										</span>
										<span v-else>
											暂无SAC资格证号
										</span>
									</div>
									<div class="desc">
										<span v-if="shouxiData.udMemo">
											{{ shouxiData.udMemo }}
										</span>
										<span v-else>
											暂无描述信息
										</span>
									</div>
								</div>
							</div>
							<div class="c_content_r_bottom">
								<div class="bottom-title">
									<h2>热门推荐</h2>
								</div>

								<div class="Nest_one">
									<div class="Sent_p" v-for="(item,index) in recommendClass" :key="index">
										<img :src="item.ncNewBigImg" alt="">
										<p>{{ item.ncName }}</p>
										<div class="Qust">
											<p class="Nice_m">{{ item.ncAuthor }}</p>
											<p class="Nice_D">{{ item.createTime }}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<v-footer></v-footer>
	</div>
</template>

<script>
	import vHeader from '../common/header'
	import vFooter from '../common/footer'

	import vPlayback from '../common/playback'
	export default {
		name: "classDetail",
		data() {
			return {
				activeName: 'second',
				ncId: 0,
				dataFrom: 'class',
				playingClassData: '',
				classDetailData: {},
				//选中的课程数据
				activeClassData: {},
				classData: [],
				shouxiData: {},
				recommendClass: [],
				aliPlayer: '',
			};
		},
		components: {
			'v-header': vHeader,
			'v-footer': vFooter,
			'v-playback': vPlayback
		},
		mounted() {
			//+-------------更新当前牛人课ID---------------------
			this.ncId = this.$route.query.ncId;

			//+-------------请求牛人课详情数据--------------------
			this.getClassDetail();

			//+-------------获取课程推荐数据----------------------
			this.getHotClass();
		},
		methods: {
			handleClick(tab, event) {
				// console.log(tab, event);
			},
			//牛人课详情数据
			getClassDetail() {
				//+----------------构建牛人课详情参数--------------
				var data = {
					ncId: this.ncId,
				};
				//+----------------请求牛人课详情数据---------------
				this.apiServer.bullClass.getDetailByWeb(this.qs.stringify(data))
					.then(res => {
						if (res.data.code == 200) {
							if (res.data.data.businessCode != 10) {
								this.$message.error(res.data.data.businessMessage);
								return false;
							}

							//+---------------更新当前选中牛人课数据---------------------
							this.classDetailData = res.data.data;
							this.classData = this.classDetailData.contentList;
							this.shouxiData = this.classDetailData.shouxi;
							this.activeClassData = this.classDetailData.videoInfo;

							//+--------------当前课程详情------------------
							if (this.activeClassData.hasBuy == 0) {
								//未购买
								this.$message.error('暂无观看权限，请您购买后观看');
								return false;
							}

							//默认播放列表中的第一个
							var playData = this.classData[0];
							this.changeClassPlay(playData);
						}
					})
					.catch(error => {
						console.log('获取牛人课详情数据异常', error);
					});
			},
			//获取课程推荐
			getHotClass() {
				//+------------------构建参数-----------------------
				let data = {
					applicationType: this.store.state.applicationType,
				};
				//+------------------发送请求-----------------------
				this.apiServer.bullClass.getDetailRecommendByWeb(data)
					.then(res => {
						if (res.data.code == 200) {
							if (res.data.data.businessCode != 10) {
								this.$message.error(res.data.data.businessMessage);
								return false;
							}
							var recommendClass = res.data.data.niuRenCourseList;
							//遍历数组，限定获取两条
							recommendClass.some((item, index) => {
								if (index > 1) {
									return true;
								}

								this.recommendClass.push(item);
							});
						}
					})
					.catch(error => {
						console.log('获取课程推荐异常', error);
					});
			},
			//切换播放资源
			changeClassPlay(item) {
				// console.log('当前播放',item);
				
				//+--------播放器已创建加载视频新地址----------
				if(this.aliPlayer){
					this.aliPlayer.loadByUrl(item.ncdConUrl);
					return false;
				}
				
				//+--------------更新当前选中------------------
				this.playingClassData = item;
				//+--------------初始化播放器------------------
				this.aliPlayerInit();
			},
			//阿里web播放器
			aliPlayerInit() {
				var _this = this;
				//+----------------------数组处理，替换键名------------------------
				let matchObj = {
					'ncdName': 'name',
					'ncdConUrl': 'source'
				}
				let result = this.classData.map(item => ({
				  [matchObj.ncdName]: item.ncdName,
				  [matchObj.ncdConUrl]: item.ncdConUrl
				}));
				
				this.aliPlayer = new Aliplayer({
					id: "bullClassPlayer", // 容器id
					source: _this.playingClassData.ncdConUrl, //视频地址
					cover: _this.playingClassData.ncdBigImg,  //播放器封面图
					autoplay: true, // 是否自动播放
					width: '100%', // 播放器宽度
					height: '675px', // 播放器高度
					isLive: false,
					preload:false,
					playsinline: true,
					controlBarVisibility: 'always',
					components: [{
						name: 'PlaylistComponent',
						type: AliPlayerComponent.PlaylistComponent,
						args: [result]
					},{
						name: 'CaptionComponent',
						type: AliPlayerComponent.CaptionComponent
					}],
					skinLayout: [
						{name: "bigPlayButton",align: "blabs",x: 50,y: 60},
						{name: "H5Loading",align: "cc"},
						{name: "errorDisplay",align: "tlabs",x: 0,y: 0},
						{name: "infoDisplay"},
						{name: "tooltip",align: "blabs",x: 50,y: 56},
						{name: "thumbnail"},
						{name: "controlBar",align: "blabs",x: 0,y: 0,
							"children": [
								{name: "progress",align: "blabs",x: 0,y: 44},
								{name: "playButton",align: "tl",x: 15,y: 12},
								{name: "timeDisplay",align: "tl",x: 10,y: 7},
								{name: "fullScreenButton",align: "tr",x: 10,y: 12},
								{name: "subtitle",align: "tr",x: 15,y: 12},
								{name: "setting",align: "tr",x: 15,y: 12},
								{name: "volume",align: "tr",x: 5,y: 10}
							]
						}
					]
				}, (aliPlayer) => {
					// console.log('播放器创建成功');
					//视频列表增加滚动
					document.querySelector('.playlist-content > .list').style = 'overflow-y:scroll';
				});

				this.aliPlayer.on('ready', () => {
					// console.log('视频可播放');

				});

				this.aliPlayer.on('pause', () => {
					// console.log('播放暂停');

				});

				this.aliPlayer.on('error', function(e) {

				});

				// 播放位置发生改变时触发，仅H5播放器
				this.aliPlayer.on('timeupdate', () => {
					let time = this.aliPlayer.getCurrentTime() // 获取播放的时间
					// console.log('视频播放位置变更',time)
				});

				this.aliPlayer.on('ended', () => {
					// console.log('播放结束');
					// this.aliPlayer.loadByUrl(this.playingClassData.ncdConUrl);
				});

				this.aliPlayer.on('onM3u8Retry', function() {
					// console.log('主播暂时离开，请稍后......');
				});

				this.aliPlayer.on('liveStreamStop', () => {
					// console.log('直播失败或已结束');

					//切换直播流
					// this.aliPlayer.loadByUrl();
				});
			}
		}
	}
</script>

<style scoped>
	.classDetail {
		width: 1201px;
		margin: 0 auto;
	}

	.video_kanban {
		background: #000000;
		/* height: 640px; */
		background: url(../../assets/img/live/no_play.png) no-repeat center;
		background-size: cover;
	}

	.class_content {
		display: flex;
		justify-content: space-between;
	}

	.class_content .class_content_left {
		width: 812px;
		/* height: 1277px; */
		border-radius: 1.25rem;
		background: #FFFFFF;


		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 33px;
	}

	.class_desc .class-data {
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
	}

	.class-data .class-name {
		margin-bottom: 20px;
	}

	.class_content_left .el-tabs {
		margin-left: 52px;
		margin-right: 64px;
		margin-top: 38px;
	}

	.class_content .class_content_right {
		margin-left: 33px;
	}

	.class_content_right .c_content_r_top {
		width: 353px;
		height: 469px;
		background: #FFFFFF;
	}

	#pane-second {
		height: 1250px;
		overflow-y: scroll;
	}

	.c_content_r_top .classUserInfo img {
		width: 84px;
		height: 84px;
		border-radius: 50px;
		margin-left: 134px;
		margin-right: 135px;
		margin-top: 39px;
	}

	.classUserInfo .name {
		margin-left: 119px;
	}

	.classUserInfo .role {
		display: flex;
		/* margin-left: 87px; */
		margin-top: 40px;
		flex-direction: row;
		justify-content: space-around;
	}

	.classUserInfo .sac_number {
		width: 220px;
		height: 20px;
		margin-left: 72px;
		margin-right: 72px;
		margin-top: 22px;

		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 20px;
	}

	.classUserInfo .desc {
		width: 283px;
		height: 100px;
		margin-left: 43px;
		margin-right: 27px;
		margin-top: 26px;
		border-radius: 12px;


		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #222222;
		line-height: 25px;
		word-break: break-all;
	}

	.class_content_right .c_content_r_bottom {
		width: 352px;
	}

	.Str_ceont {
		display: flex;
		width: 90%;
	}

	.Next {
		width: 812px;
		height: 1277px;
		background: #FFFFFF;
		border-radius: 12px;

	}

	.class-item {
		height: 144px;
		display: flex;
		margin-bottom: 48px;
		cursor: pointer;
	}

	.class-item img {
		width: 256px;
		height: 144px;
	}

	.class-item .item-content {
		width: 425px;
		margin-left: 15px;
	}

	.item-content p:nth-child(1) {
		/* width: 425px;
	      height: 56px; */
		font-size: 20px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		margin-bottom: 60px;
	}

	.item-content p:nth-child(2) {
		/* width: 104px;
	     height: 28px; */
		font-size: 20px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
	}

	.Ster_Btn img {
		margin: 0 auto;
		margin-left: 135px
	}

	.Ster_Btn .zhang_n {
		font-size: 24px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #222222;
		line-height: 33px;
		color: red
	}

	.People {
		width: 64px;
		height: 30px;
		border-radius: 6px;
		border: 1px solid #979797;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 30px;
		text-align: center;
		margin-left: 50px
	}

	.Tech {
		height: 30px;
		border-radius: 6px;
		border: 1px solid #979797;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 30px;
		text-align: center;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.Shou_xi {
		width: 283px;
		height: 100px;
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #222222;
		line-height: 25px;
		margin-left: 43px;
		margin-top: 26px
	}

	.Plernt {
		height: 20px;
		margin-top: 22px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 20px;
		margin-left: 72px;
	}

	.el-tabs__heade {
		margin-left: 53px;
		margin-right: 53px;
	}

	.Nest_one {
		border-radius: 8px;
		margin-left: 33pxs;
	}

	.Nest_one h2 {
		width: 96px;
		height: 33px;
		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 33px;
		margin-top: 48px;
		margin-bottom: 24px;
	}

	.Sent_p img {
		width: 320px;
		height: 180px;
	}

	.Sent_p p {

		font-size: 20px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 28px;
		margin-top: 16px;
	}

	.Sent_p .Nice_m {
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 25px;
	}

	.Sent_p .Nice_D {
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 25px;
	}

	.Qust {
		display: flex;
		flex-direction: row;
		width: 322px;
		justify-content: space-between;
	}

	.Sent_p {
		height: 342px;
		background: #FFFFFF;
		border-radius: 8px;
		padding: 16px
	}
</style>



// WEBPACK FOOTER //
// src/components/bull_class/classDetail.vue